import {
  Box,
  Button,
  IconButton,
  Stack,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material'

export const StyledBookletContainer = styled('div')(({ theme }) => ({
  borderLeft: `6px solid ${theme.palette.secondary.light}`,
  borderRight: `6px solid ${theme.palette.secondary.light}`,
  height: 'calc(100vh - 64px)',
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'auto',
  '& .pdfContainer': {
    overflowY: 'auto',
    height: 'calc(100vh - 64px)',
  },
}))

export const StyledZoomIconButton = styled(IconButton)(({ theme }) => ({
  width: '40px',
  height: '40px',
  borderRadius: '8px',
  backgroundColor: 'lightgray',
}))

export const StyledIconButton = styled(IconButton)(() => ({
  position: 'relative',
  right: 0,
  transform: 'translateX(-25%)',
  borderRadius: '50%',
  backgroundColor: 'blue',
  color: 'white',
  width: 40,
  height: 40,
  padding: 0,
  transition: 'right 0.3s ease-out',
}))

export const StyledPdfContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflowY: 'auto',
  overflowX: 'auto',
  width: '100%',
  padding: '0',
}))

export const StyledZoomControlsContainer = styled(Box)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '8px',
}))

export const StyledCheckBoxStack = styled(Stack)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '20px',
  backgroundColor: 'black',
  height: '60px',
  flexDirection: 'row',
}))

export const RefreshButton = styled(IconButton)(({ theme }) => ({
  width: '40px',
  height: '40px',
  color: 'white',
  borderRadius: '10px',
  border: '1px solid white',
}))

export const StyledFooterContainer = styled(Box)(({ theme }) => ({
  height: '60px',
  color: 'white',
  padding: '10px 20px',
  backgroundColor: '#121212',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export const StyledMarksContainer = styled(Box)(({ theme }) => ({
  width: '80px',
  backgroundColor: 'white',
  border: `1px solid #12121233`,
  borderRadius: '10px',
  padding: '10px',
  display: 'flex',
  justifyContent: 'space-between',
  gap: '8px',
  alignItems: 'center',
  '& fieldset': {
    display: 'none',
  },
  '& p': {
    color: '#222222',
  },
}))

export const BpIcon = styled('span')(({}) => ({
  borderRadius: 3,
  width: 18,
  height: 18,
  marginLeft: '2px',
  border: '1px solid #CBCBCB',
  backgroundColor: '#F8F8F8',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: '#F8F8F8',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
  },
}))

export const BpCheckedIcon = styled(BpIcon)<{
  checkBoxType: 'satisfactory' | 'absent'
}>(({ theme, checkBoxType }) => ({
  border:
    checkBoxType == 'absent' ? `1px dashed #F2353C` : `1px dashed #609D52`,
  backgroundImage:
    'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  marginLeft: '2px',
  '&:before': {
    content: '""',
    display: 'block',
    width: 8,
    height: 8,
    margin: '4px',
    left: '2px',
    background: checkBoxType == 'absent' ? '#F2353C' : '#609D52',
    borderRadius: '2px',
  },
}))

export const StyledTitleBlock = styled(Box)(({ theme }) => ({
  padding: '5px 1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: `3px solid ${theme.palette.secondary.light}`,
  height: '60px',
  '& .row2': {
    display: 'flex',
    gap: '20px',
  },
}))

export const DarkTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    placement="top-end"
    arrow
    classes={{ popper: className }}
    {...props}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontSize: '12px',
  },
}))

export const ActionButtonFilled = styled(Button)(({ theme }) => ({}))
